
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aktuell4TUdQ7dR8pelAfW8_8fIQfu8t6uHArIRpBMD5_5rKr0Meta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/aktuell.vue?macro=true";
import { default as auswahlv1uKYU_7UIRAfeM9RaX65OlR5PvH29hFNIPBFx_Gt_EMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/auswahl.vue?macro=true";
import { default as werkliste0cOZSGPeXkYmkdKEKeB9Crz6sumfFEpVZEgbYBrdL8gMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/werkliste.vue?macro=true";
import { default as _91servicearea_slug_93SpVJcccEhg9XIm8Ou3AfPHVCSa1w9ZouXXaWXutVC3EMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/leistungen/[servicearea_slug].vue?macro=true";
import { default as _91project_slug_93MUTCBtkVX8j8EpJnj_twhxA7M_C86_cOmIl__CQ1k_oMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/[project_slug].vue?macro=true";
import { default as _91joboffer_slug_93GxIm_YTVitl42gsURfBrJDDG9p7Ah89b2tS4ZqZod5QMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/stellenangebote/[joboffer_slug].vue?macro=true";
import { default as kontaktz6BYxCpVsrw2ps7kMjV0LL5ZNWT7DmYQ2XyVMyhm0n0Meta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/kontakt.vue?macro=true";
import { default as _91article_slug_93oX1dmgCX8I_qbS4nTpBQQ1c3tYCOq4knDr5cHPXK7UwMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/[article_slug].vue?macro=true";
import { default as indexneQsofewC5Hz6lr_73YmKLaE4LyyOk4JwWaR_ok37cAMeta } from "/home/snaumann/Development/public_html/dundp/public/app/pages/index.vue?macro=true";
export default [
  {
    name: "current_projects",
    path: "/projekte/aktuell",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/aktuell.vue").then((m) => Object.assign(m.default, { __name: aktuell4TUdQ7dR8pelAfW8_8fIQfu8t6uHArIRpBMD5_5rKr0Meta?.name ?? "current_projects" }))
  },
  {
    name: "featured_projects",
    path: "/projekte/auswahl",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/auswahl.vue").then((m) => Object.assign(m.default, { __name: auswahlv1uKYU_7UIRAfeM9RaX65OlR5PvH29hFNIPBFx_Gt_EMeta?.name ?? "featured_projects" }))
  },
  {
    name: "all_projects",
    path: "/projekte/werkliste",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/werkliste.vue").then((m) => Object.assign(m.default, { __name: werkliste0cOZSGPeXkYmkdKEKeB9Crz6sumfFEpVZEgbYBrdL8gMeta?.name ?? "all_projects" }))
  },
  {
    name: "servicearea-detail",
    path: "/leistungen/:servicearea_slug()",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/leistungen/[servicearea_slug].vue").then((m) => Object.assign(m.default, { __name: _91servicearea_slug_93SpVJcccEhg9XIm8Ou3AfPHVCSa1w9ZouXXaWXutVC3EMeta?.name ?? "servicearea-detail" }))
  },
  {
    name: "project-detail",
    path: "/projekte/:project_slug()",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/projekte/[project_slug].vue").then((m) => Object.assign(m.default, { __name: _91project_slug_93MUTCBtkVX8j8EpJnj_twhxA7M_C86_cOmIl__CQ1k_oMeta?.name ?? "project-detail" }))
  },
  {
    name: "joboffer-detail",
    path: "/stellenangebote/:joboffer_slug()",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/stellenangebote/[joboffer_slug].vue").then((m) => Object.assign(m.default, { __name: _91joboffer_slug_93GxIm_YTVitl42gsURfBrJDDG9p7Ah89b2tS4ZqZod5QMeta?.name ?? "joboffer-detail" }))
  },
  {
    name: "contact",
    path: "/kontakt",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/kontakt.vue").then((m) => Object.assign(m.default, { __name: kontaktz6BYxCpVsrw2ps7kMjV0LL5ZNWT7DmYQ2XyVMyhm0n0Meta?.name ?? "contact" }))
  },
  {
    name: "article-detail",
    path: "/:article_slug()",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/[article_slug].vue").then((m) => Object.assign(m.default, { __name: _91article_slug_93oX1dmgCX8I_qbS4nTpBQQ1c3tYCOq4knDr5cHPXK7UwMeta?.name ?? "article-detail" }))
  },
  {
    name: "home",
    path: "/",
    component: () => import("/home/snaumann/Development/public_html/dundp/public/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: indexneQsofewC5Hz6lr_73YmKLaE4LyyOk4JwWaR_ok37cAMeta?.name ?? "home" }))
  }
]